import http from '@/api/http';
// 获取分页页面的具体内容
export function getShareData (params) {
  return http.get('api/share/getShareInfo', params)
}

export const bigapi = 'https://www.itdks.com';
export default {
  bigapi
}



// WEBPACK FOOTER //
// ./src/api/modules/common/common.js